"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.whichAddon = exports.updateTopupMinimumValue = exports.updateTopupDefaultValue = exports.updateAddonsAfterCancel = exports.updateAddons = exports.setStaticAddons = exports.setMappedActiveAddons = exports.setEligibleAddonsSuccess = exports.setEligibleAddonsRequest = exports.setEligibleAddonsFailure = exports.setDefaultAddonIcon = exports.setCurrentScreen = exports.setCurrentMode = exports.setAddonIcons = exports.sendTags = exports.postCancelAddonSuccess = exports.postCancelAddonRequest = exports.postCancelAddonFailure = exports.openTopup = exports.getBalanceDetailsRequest = exports.getActiveAddonsSuccess = exports.getActiveAddonsRequest = exports.getActiveAddonsFailure = exports.fetchEligibleAddons = exports.fetchActiveAddons = exports.clearEligibleAddons = exports.buyAddonSuccess = exports.buyAddonRequest = exports.buyAddonFailure = exports.UPDATE_TOP_UP_MIN_VALUE = exports.UPDATE_TOP_UP_DEFAULT_VALUE = exports.UPDATE_ADDONS_AFTER_CANCELLATION = exports.UPDATE_ADDONS = exports.STATIC_ADDONS = exports.SHOW_POPUP = exports.SET_MAPPED_ACTIVE_ADDONS = exports.SET_ELIGIBLE_ADDONS_SUCCESS = exports.SET_ELIGIBLE_ADDONS_REQUEST = exports.SET_ELIGIBLE_ADDONS_FAILURE = exports.SET_DEFAULT_ADDON_ICON = exports.SET_CURRENT_SCREEN = exports.SET_CURRENT_MODE = exports.SET_ADDON_ICONS = exports.SEND_TAGS = exports.RESET_CANCEL_ADDON = exports.POST_CANCEL_ADDON_SUCCESS = exports.POST_CANCEL_ADDON_REQUEST = exports.POST_CANCEL_ADDON_FAILURE = exports.OPEN_TOPUP = exports.HIDE_POPUP = exports.GET_BALANCE_DETAILS_SUCCESS = exports.GET_BALANCE_DETAILS_REQUEST = exports.GET_BALANCE_DETAILS_FAILURE = exports.GET_ACTIVE_ADDONS_SUCCESS = exports.GET_ACTIVE_ADDONS_REQUEST = exports.GET_ACTIVE_ADDONS_FAILURE = exports.FETCH_ELIGIBLE_ADDONS = exports.FETCH_ACTIVE_ADDONS = exports.CLEAR_ELIGIBLE_ADDONS = exports.CANCEL_ADDON = exports.BUY_ADDON_SUCCESS = exports.BUY_ADDON_REQUEST = exports.BUY_ADDON_FAILURE = void 0;
var _appConstants = require("../appConstants");
var _package = require("../../package.json");
var POST_CANCEL_ADDON_SUCCESS = "".concat(_package.name, "/POST_CANCEL_ADDON_SUCCESS");
exports.POST_CANCEL_ADDON_SUCCESS = POST_CANCEL_ADDON_SUCCESS;
var POST_CANCEL_ADDON_FAILURE = "".concat(_package.name, "/POST_CANCEL_ADDON_FAILURE");
exports.POST_CANCEL_ADDON_FAILURE = POST_CANCEL_ADDON_FAILURE;
var POST_CANCEL_ADDON_REQUEST = "".concat(_package.name, "/POST_CANCEL_ADDON_REQUEST");
exports.POST_CANCEL_ADDON_REQUEST = POST_CANCEL_ADDON_REQUEST;
var RESET_CANCEL_ADDON = "".concat(_package.name, "/RESET_CANCEL_ADDON");
exports.RESET_CANCEL_ADDON = RESET_CANCEL_ADDON;
var SET_ADDON_ICONS = "".concat(_package.name, "/SET_ADDON_ICONS");
// TODO: Remove after integration
exports.SET_ADDON_ICONS = SET_ADDON_ICONS;
var STATIC_ADDONS = "".concat(_package.name, "/STATIC_ADDONS");
exports.STATIC_ADDONS = STATIC_ADDONS;
var SET_DEFAULT_ADDON_ICON = "".concat(_package.name, "/SET_DEFAULT_ADDON_ICON");
exports.SET_DEFAULT_ADDON_ICON = SET_DEFAULT_ADDON_ICON;
var HIDE_POPUP = "".concat(_package.name, "/HIDE_POPUP");
exports.HIDE_POPUP = HIDE_POPUP;
var SHOW_POPUP = "".concat(_package.name, "/SHOW_POPUP");
exports.SHOW_POPUP = SHOW_POPUP;
var UPDATE_ADDONS_AFTER_CANCELLATION = "".concat(_package.name, "/UPDATE_ADDONS_AFTER_CANCELLATION");
exports.UPDATE_ADDONS_AFTER_CANCELLATION = UPDATE_ADDONS_AFTER_CANCELLATION;
var CANCEL_ADDON = "".concat(_package.name, "/CANCEL_ADDON");
exports.CANCEL_ADDON = CANCEL_ADDON;
var SET_CURRENT_MODE = "".concat(_package.name, "/SET_CURRENT_MODE");
exports.SET_CURRENT_MODE = SET_CURRENT_MODE;
var FETCH_ELIGIBLE_ADDONS = "".concat(_package.name, "/FETCH_ELIGIBLE_ADDONS");
exports.FETCH_ELIGIBLE_ADDONS = FETCH_ELIGIBLE_ADDONS;
var SET_ELIGIBLE_ADDONS_REQUEST = "".concat(_package.name, "/SET_ELIGIBLE_ADDONS_REQUEST");
exports.SET_ELIGIBLE_ADDONS_REQUEST = SET_ELIGIBLE_ADDONS_REQUEST;
var SET_ELIGIBLE_ADDONS_SUCCESS = "".concat(_package.name, "/SET_ELIGIBLE_ADDONS_SUCCESS");
exports.SET_ELIGIBLE_ADDONS_SUCCESS = SET_ELIGIBLE_ADDONS_SUCCESS;
var SET_ELIGIBLE_ADDONS_FAILURE = "".concat(_package.name, "/SET_ELIGIBLE_ADDONS_FAILURE");
exports.SET_ELIGIBLE_ADDONS_FAILURE = SET_ELIGIBLE_ADDONS_FAILURE;
var CLEAR_ELIGIBLE_ADDONS = "".concat(_package.name, "/CLEAR_ELIGIBLE_ADDONS");
exports.CLEAR_ELIGIBLE_ADDONS = CLEAR_ELIGIBLE_ADDONS;
var UPDATE_TOP_UP_DEFAULT_VALUE = '@topup/UPDATE_TOP_UP_DEFAULT_VALUE';
exports.UPDATE_TOP_UP_DEFAULT_VALUE = UPDATE_TOP_UP_DEFAULT_VALUE;
var UPDATE_TOP_UP_MIN_VALUE = '@topup/UPDATE_TOP_UP_MIN_VALUE';
exports.UPDATE_TOP_UP_MIN_VALUE = UPDATE_TOP_UP_MIN_VALUE;
var OPEN_TOPUP = '@topup/OPEN_TOPUP';
exports.OPEN_TOPUP = OPEN_TOPUP;
var GET_BALANCE_DETAILS_REQUEST = "@generic-actions/GET_BALANCE_DETAILS_REQUEST";
exports.GET_BALANCE_DETAILS_REQUEST = GET_BALANCE_DETAILS_REQUEST;
var GET_BALANCE_DETAILS_SUCCESS = "@generic-actions/GET_BALANCE_DETAILS_SUCCESS";
exports.GET_BALANCE_DETAILS_SUCCESS = GET_BALANCE_DETAILS_SUCCESS;
var GET_BALANCE_DETAILS_FAILURE = "@generic-actions/GET_BALANCE_DETAILS_FAILURE";
exports.GET_BALANCE_DETAILS_FAILURE = GET_BALANCE_DETAILS_FAILURE;
var GET_ACTIVE_ADDONS_REQUEST = "".concat(_package.name, "/GET_ACTIVE_ADDONS_REQUEST");
exports.GET_ACTIVE_ADDONS_REQUEST = GET_ACTIVE_ADDONS_REQUEST;
var GET_ACTIVE_ADDONS_SUCCESS = "".concat(_package.name, "/GET_ACTIVE_ADDONS_SUCCESS");
exports.GET_ACTIVE_ADDONS_SUCCESS = GET_ACTIVE_ADDONS_SUCCESS;
var GET_ACTIVE_ADDONS_FAILURE = "".concat(_package.name, "/GET_ACTIVE_ADDONS_FAILURE");
exports.GET_ACTIVE_ADDONS_FAILURE = GET_ACTIVE_ADDONS_FAILURE;
var FETCH_ACTIVE_ADDONS = "".concat(_package.name, "/FETCH_ACTIVE_ADDONS");
exports.FETCH_ACTIVE_ADDONS = FETCH_ACTIVE_ADDONS;
var SET_MAPPED_ACTIVE_ADDONS = "".concat(_package.name, "/SET_MAPPED_ACTIVE_ADDONS");
exports.SET_MAPPED_ACTIVE_ADDONS = SET_MAPPED_ACTIVE_ADDONS;
var SEND_TAGS = 'SEND_TAGS';
exports.SEND_TAGS = SEND_TAGS;
var postCancelAddonSuccess = function postCancelAddonSuccess(response) {
  return {
    type: POST_CANCEL_ADDON_SUCCESS,
    payload: response
  };
};
exports.postCancelAddonSuccess = postCancelAddonSuccess;
var postCancelAddonFailure = function postCancelAddonFailure(error) {
  return {
    type: POST_CANCEL_ADDON_FAILURE,
    payload: error
  };
};
exports.postCancelAddonFailure = postCancelAddonFailure;
var postCancelAddonRequest = function postCancelAddonRequest(payload) {
  return {
    type: POST_CANCEL_ADDON_REQUEST,
    payload: payload
  };
};
exports.postCancelAddonRequest = postCancelAddonRequest;
var UPDATE_ADDONS = "".concat(_appConstants.pkgName, "/UPDATE_ADDONS");
exports.UPDATE_ADDONS = UPDATE_ADDONS;
var updateAddons = function updateAddons(addons) {
  return {
    type: UPDATE_ADDONS,
    payload: addons
  };
};
exports.updateAddons = updateAddons;
var setCurrentMode = function setCurrentMode(payload) {
  return {
    type: SET_CURRENT_MODE,
    payload: payload
  };
};
exports.setCurrentMode = setCurrentMode;
var setAddonIcons = function setAddonIcons(iconsList) {
  return {
    type: SET_ADDON_ICONS,
    payload: iconsList
  };
};
exports.setAddonIcons = setAddonIcons;
var setDefaultAddonIcon = function setDefaultAddonIcon(icon) {
  return {
    type: SET_DEFAULT_ADDON_ICON,
    payload: icon
  };
};
exports.setDefaultAddonIcon = setDefaultAddonIcon;
var updateAddonsAfterCancel = function updateAddonsAfterCancel(payload) {
  return {
    type: UPDATE_ADDONS_AFTER_CANCELLATION,
    payload: payload
  };
};
exports.updateAddonsAfterCancel = updateAddonsAfterCancel;
var whichAddon = function whichAddon(payload) {
  return {
    type: CANCEL_ADDON,
    payload: payload
  };
};

// TODO: Remove after integration
exports.whichAddon = whichAddon;
var setStaticAddons = function setStaticAddons(payload) {
  return {
    type: STATIC_ADDONS,
    payload: payload
  };
};
exports.setStaticAddons = setStaticAddons;
var fetchEligibleAddons = function fetchEligibleAddons(queryParam) {
  return {
    type: FETCH_ELIGIBLE_ADDONS,
    queryParam: queryParam
  };
};
exports.fetchEligibleAddons = fetchEligibleAddons;
var setEligibleAddonsRequest = function setEligibleAddonsRequest() {
  return {
    type: SET_ELIGIBLE_ADDONS_REQUEST
  };
};
exports.setEligibleAddonsRequest = setEligibleAddonsRequest;
var setEligibleAddonsSuccess = function setEligibleAddonsSuccess(payload) {
  return {
    type: SET_ELIGIBLE_ADDONS_SUCCESS,
    payload: payload
  };
};
exports.setEligibleAddonsSuccess = setEligibleAddonsSuccess;
var setEligibleAddonsFailure = function setEligibleAddonsFailure(payload) {
  return {
    type: SET_ELIGIBLE_ADDONS_FAILURE,
    payload: payload
  };
};
exports.setEligibleAddonsFailure = setEligibleAddonsFailure;
var clearEligibleAddons = function clearEligibleAddons() {
  return {
    type: CLEAR_ELIGIBLE_ADDONS
  };
};
exports.clearEligibleAddons = clearEligibleAddons;
var openTopup = function openTopup() {
  return {
    type: OPEN_TOPUP
  };
};
exports.openTopup = openTopup;
var updateTopupDefaultValue = function updateTopupDefaultValue(payload) {
  return {
    type: UPDATE_TOP_UP_DEFAULT_VALUE,
    payload: payload
  };
};
exports.updateTopupDefaultValue = updateTopupDefaultValue;
var updateTopupMinimumValue = function updateTopupMinimumValue(payload) {
  return {
    type: UPDATE_TOP_UP_MIN_VALUE,
    payload: payload
  };
};
exports.updateTopupMinimumValue = updateTopupMinimumValue;
var getBalanceDetailsRequest = function getBalanceDetailsRequest() {
  return {
    type: GET_BALANCE_DETAILS_REQUEST
  };
};
exports.getBalanceDetailsRequest = getBalanceDetailsRequest;
var getActiveAddonsRequest = function getActiveAddonsRequest() {
  return {
    type: GET_ACTIVE_ADDONS_REQUEST
  };
};
exports.getActiveAddonsRequest = getActiveAddonsRequest;
var getActiveAddonsSuccess = function getActiveAddonsSuccess(payload) {
  return {
    type: GET_ACTIVE_ADDONS_SUCCESS,
    payload: payload
  };
};
exports.getActiveAddonsSuccess = getActiveAddonsSuccess;
var getActiveAddonsFailure = function getActiveAddonsFailure(payload) {
  return {
    type: GET_ACTIVE_ADDONS_FAILURE,
    payload: payload
  };
};
exports.getActiveAddonsFailure = getActiveAddonsFailure;
var fetchActiveAddons = function fetchActiveAddons(queryParam) {
  return {
    type: FETCH_ACTIVE_ADDONS,
    queryParam: queryParam
  };
};
exports.fetchActiveAddons = fetchActiveAddons;
var setMappedActiveAddons = function setMappedActiveAddons(payload) {
  return {
    type: SET_MAPPED_ACTIVE_ADDONS,
    payload: payload
  };
};

// Buy addon actions
exports.setMappedActiveAddons = setMappedActiveAddons;
var BUY_ADDON_REQUEST = "".concat(_appConstants.pkgName, "/BUY_ADDON_REQUEST");
exports.BUY_ADDON_REQUEST = BUY_ADDON_REQUEST;
var BUY_ADDON_SUCCESS = "".concat(_appConstants.pkgName, "/BUY_ADDON_SUCCESS");
exports.BUY_ADDON_SUCCESS = BUY_ADDON_SUCCESS;
var BUY_ADDON_FAILURE = "".concat(_appConstants.pkgName, "/BUY_ADDON_FAILURE");
exports.BUY_ADDON_FAILURE = BUY_ADDON_FAILURE;
var SET_CURRENT_SCREEN = "@".concat(_appConstants.pkgName, "/SET_CURRENT_SCREEN");
exports.SET_CURRENT_SCREEN = SET_CURRENT_SCREEN;
var buyAddonRequest = function buyAddonRequest(payload, purchaseFlowErrorHandling) {
  return {
    type: BUY_ADDON_REQUEST,
    payload: payload,
    purchaseFlowErrorHandling: purchaseFlowErrorHandling
  };
};
exports.buyAddonRequest = buyAddonRequest;
var buyAddonSuccess = function buyAddonSuccess() {
  return {
    type: BUY_ADDON_SUCCESS
  };
};
exports.buyAddonSuccess = buyAddonSuccess;
var buyAddonFailure = function buyAddonFailure(error) {
  return {
    type: BUY_ADDON_FAILURE,
    payload: error
  };
};
exports.buyAddonFailure = buyAddonFailure;
var setCurrentScreen = function setCurrentScreen(currentScreen) {
  return {
    type: SET_CURRENT_SCREEN,
    payload: currentScreen
  };
};
exports.setCurrentScreen = setCurrentScreen;
var sendTags = function sendTags(payload) {
  return {
    type: SEND_TAGS,
    payload: payload
  };
};
exports.sendTags = sendTags;